import { render, staticRenderFns } from "./squareModelSingle.vue?vue&type=template&id=1b52ad24&scoped=true&"
import script from "./squareModelSingle.vue?vue&type=script&lang=js&"
export * from "./squareModelSingle.vue?vue&type=script&lang=js&"
import style0 from "./squareModelSingle.vue?vue&type=style&index=0&id=1b52ad24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b52ad24",
  null
  
)

export default component.exports